import Vue from 'vue'
import App from './App.vue'
import {router} from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueNativeSock from 'vue-native-websocket'

Vue.config.productionTip = false
const scheme = location.protocol === 'https:' ? 'wss' : 'ws'
Vue.use(VueNativeSock, `${scheme}://${location.hostname}:${location.port}/client`, {
    reconnection: true,
    reconnectionAttempts: 5000,
    reconnectionDelay: 3000,
    store: store,
    format: 'json'
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
